// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hn_BLj42Zy4SDN3FH9sP {
    animation: IRiAx7zv27zmdV8kjj2c 0.7s;
    background: white;
    border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]};
    border-radius: 5px;
    box-shadow: 0 2px 4px rgb(0 0 0 / 10%);
    min-width: 250px;
    transition: transform 0.6s ease-in-out;
}

.mZgV_DuP1iiRS7PMd52D {
    bottom: 12px;
    max-height: calc(100vh - 24px);
    overflow-x: hidden;
    overflow-y: scroll;
    position: fixed;
    right: 32px;
    scrollbar-color: rgb(0 0 0 / 10%) transparent;
    /* thumb and track color */
    scrollbar-width: thin;
    width: 33%;
    z-index: 50;
}

.mZgV_DuP1iiRS7PMd52D::-webkit-scrollbar {
    width: 5px;
    /* for vertical scrollbars */
}

.mZgV_DuP1iiRS7PMd52D::-webkit-scrollbar-thumb {
    background: rgb(0 0 0 / 10%);
    border-radius: 5px;
}

.mZgV_DuP1iiRS7PMd52D .hn_BLj42Zy4SDN3FH9sP+.hn_BLj42Zy4SDN3FH9sP {
    margin-top: 16px;
}

.M3rk47BZD5Xdje9p0GIA {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 16px;
}

.qgGeRA2fmNoEK7rGPDJH {
    font-size: 18px;
    font-weight: 500;
    margin: 0;
}

.sZOBsK072wlpKov0RleA {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    margin: 0;
}

button.tBq37QkCJtVgL_5Tz7la {
    background: none;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
}

button.tBq37QkCJtVgL_5Tz7la .jS82qdQtuqBUUXUQBIko {
    font-size: 18px;
}

.xuYYwTb06839H_AA9QQE {
    border-radius: 5px 5px 0 0;
    height: 4px;
}

.l4T18Y8XnY78ayTqIja_ {
    animation: tKyDPLs3S_l0CpxyV_dQ 0.7s;
    opacity: 0;
    transition: transform 0.6s ease-in-out;
}

.y0CeTXAPTbt9vXuGg2wf {
    margin: 0 16px;
}

@keyframes IRiAx7zv27zmdV8kjj2c {
    from {
        transform: translateX(100%);
    }

    to {
        transform: translateX(0);
    }
}

@keyframes tKyDPLs3S_l0CpxyV_dQ {
    from {
        opacity: 1;
        transform: translateX(0);
    }

    to {
        opacity: 0;
        transform: translateX(100%);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/library/Toasts/Toasts.module.css"],"names":[],"mappings":"AAGA;IACI,oCAA8B;IAC9B,iBAAiB;IACjB,8DAAkC;IAClC,kBAAkB;IAClB,sCAAsC;IACtC,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,6CAA6C;IAC7C,0BAA0B;IAC1B,qBAAqB;IACrB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,mDAAwB;IACxB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,mDAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,oCAA+B;IAC/B,UAAU;IACV,sCAAsC;AAC1C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;;IAEA;QACI,UAAU;QACV,2BAA2B;IAC/B;AACJ","sourcesContent":["@value colors: \"../style/colors.css\";\n@value color-gray-light, color-text-subtle from colors;\n\n.toast {\n    animation: toast-in-right 0.7s;\n    background: white;\n    border: 1px solid color-gray-light;\n    border-radius: 5px;\n    box-shadow: 0 2px 4px rgb(0 0 0 / 10%);\n    min-width: 250px;\n    transition: transform 0.6s ease-in-out;\n}\n\n.toastContainer {\n    bottom: 12px;\n    max-height: calc(100vh - 24px);\n    overflow-x: hidden;\n    overflow-y: scroll;\n    position: fixed;\n    right: 32px;\n    scrollbar-color: rgb(0 0 0 / 10%) transparent;\n    /* thumb and track color */\n    scrollbar-width: thin;\n    width: 33%;\n    z-index: 50;\n}\n\n.toastContainer::-webkit-scrollbar {\n    width: 5px;\n    /* for vertical scrollbars */\n}\n\n.toastContainer::-webkit-scrollbar-thumb {\n    background: rgb(0 0 0 / 10%);\n    border-radius: 5px;\n}\n\n.toastContainer .toast+.toast {\n    margin-top: 16px;\n}\n\n.content {\n    align-items: center;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    padding: 16px;\n}\n\n.title {\n    font-size: 18px;\n    font-weight: 500;\n    margin: 0;\n}\n\n.description {\n    color: color-text-subtle;\n    margin: 0;\n}\n\nbutton.button {\n    background: none;\n    color: color-text-subtle;\n}\n\nbutton.button .icon {\n    font-size: 18px;\n}\n\n.time {\n    border-radius: 5px 5px 0 0;\n    height: 4px;\n}\n\n.hideToast {\n    animation: toast-out-right 0.7s;\n    opacity: 0;\n    transition: transform 0.6s ease-in-out;\n}\n\n.textContainer {\n    margin: 0 16px;\n}\n\n@keyframes toast-in-right {\n    from {\n        transform: translateX(100%);\n    }\n\n    to {\n        transform: translateX(0);\n    }\n}\n\n@keyframes toast-out-right {\n    from {\n        opacity: 1;\n        transform: translateX(0);\n    }\n\n    to {\n        opacity: 0;\n        transform: translateX(100%);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../style/colors.css"`,
	"color-gray-light": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"toast": `hn_BLj42Zy4SDN3FH9sP`,
	"toast-in-right": `IRiAx7zv27zmdV8kjj2c`,
	"toastContainer": `mZgV_DuP1iiRS7PMd52D`,
	"content": `M3rk47BZD5Xdje9p0GIA`,
	"title": `qgGeRA2fmNoEK7rGPDJH`,
	"description": `sZOBsK072wlpKov0RleA`,
	"button": `tBq37QkCJtVgL_5Tz7la`,
	"icon": `jS82qdQtuqBUUXUQBIko`,
	"time": `xuYYwTb06839H_AA9QQE`,
	"hideToast": `l4T18Y8XnY78ayTqIja_`,
	"toast-out-right": `tKyDPLs3S_l0CpxyV_dQ`,
	"textContainer": `y0CeTXAPTbt9vXuGg2wf`
};
export default ___CSS_LOADER_EXPORT___;
